// extracted by mini-css-extract-plugin
export var deliveryRow = "_pc-a";
export var fixedHeight = "_pc-4";
export var freightLogo = "_pc-9";
export var fullWidth = "_pc-3";
export var priceColumn = "_pc-5";
export var radioSelected = "_pc-7";
export var radioUnselected = "_pc-6";
export var selectedOption = "_pc-2";
export var selectedOptionContainer = "_pc-1";
export var selection = "_pc-0";
export var tallSkeletonText = "_pc-8";